export default {
  ffc_form: {},
  ffc_banner: {},
  ffc_partner: {},
  ffc_testimonial: {},
  ffc_all_testimonial: {},
  selectedBanner: {},
  selectedPartner: {},
  ffc_hub: {},
  selectedHub: {},
  ffc_review: {},

  // ///////Corporate Events//////////
  selected_event: {},
  selectservice: "",
};
